/* eslint-disable no-undef */
import { useAuth0 } from "@auth0/auth0-react";
import { TableContainer } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import GridViewIcon from '@mui/icons-material/GridView';
import Paper from "@mui/material/Paper";
import { ReactComponent as AddAccounSVG } from "assets/icons/add-account.svg";
import { ReactComponent as FilterActive } from "assets/icons/filter-active-icon.svg";
import { ReactComponent as FilterIcon } from "assets/icons/filter-icon.svg";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog/index";
import ExportOptions from "components/ExportOptions/ExportOptions";
import FilterTabs from "components/filterTabs/FilterTabs";
import MainTabs from "components/mainTabs/MainTabs";
import { useUrlTab } from "hook/useUrlTab";
import { useFormik } from "formik";
import { SubHeader } from "layout/SubHeader";
import MemberService from "Lib/API/Member/index";
import UserService from "Lib/API/users/index";
import * as filterVariables from "pages/Members/MemberFilters/Variables";
import React, { useCallback, useEffect, useState } from "react";
import { formatPhoneNumber } from 'react-phone-number-input';
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { PulseLoader } from 'react-spinners';
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import MyModal from "../../components/MyModal";
import NotAuthorized from "../../components/NotAuthorized";
import AccountListView from "./accountListView/AccountListView";
import AddNewAccount from "./AddNewAccount";
import AddNewUser from "./AddNewUser";
import { accountColumns, contactColumns } from "./exportColumns";
import Filter from "./filter";
import GridComponent from "./GridComponent";
import InviteMember from "./invitation";
import InvitationModal from "./InvitationModal/InvitationModal";
import { MemberFilters } from "./MemberFilters/MemberFilters";
import MemberTable from "./MemberTables/memberTable";
import "./style.scss";
import { FiltersWrapper, Wrapper, WrapperButtons } from './Theme';

const memberTabs = [
  {
    id: "account",
    title: "Accounts",
    value: "account"
  },
  {
    id: "people",
    title: "People",
    value: "people"
  },
];

const Members = () => {
  const tableContainerRef = React.useRef(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      account: {
      },
      people: {
      },
      account_type: ['member'],
    },
    validationSchema: '',
  });

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [userFamily, setUserFamily] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const [openInvitationModel, setOpenInvitationModel] = React.useState(false);
  const [currentContact, setCurrentContact] = useState({});
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(false);
  const [disableMemberUSerModal, setDisableMemberUserModal] = useState({
    open: false,
    data: {},
    loading: false,
  });
  let orgInfo = localStorage?.getItem("authorizedModules")
    ? JSON.parse(localStorage?.getItem("authorizedModules"))
    : [];

  const storedAccountView = localStorage.getItem("accountView");

  const [toggle, setToggle] = useState(true);
  // ?tab=account|people opens that tab (e.g. from the global search)
  useUrlTab((tab) => setToggle(tab === "account"), memberTabs.map((tab) => tab.value));
  const { getAccessTokenSilently } = useAuth0();
  const [data, setData] = useState([]);
  const [accountCardsData, setAccountCardsData] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [openAddModel, setOpenAddModel] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [isMembersActive, setIsMembersActive] = useState(true);
  const [page, setPage] = useState(1);
  const [peoplePage, setPeoplePage] = useState(1);
  const [totalPeople, setTotalPeople] = useState();
  const [peoplelist, setPeopleList] = useState([]);
  const [confirmClose, setConfirmClose] = useState(false);
  const [accountView, setAccountView] = useState(storedAccountView || "cards");
  const [exportAccountsData, setExportAccountsData] = useState([]);
  const [exportContactsData, setExportContactsData] = useState([]);

  const pageFilter = toggle ? page : peoplePage

  const [show, setShow] = useState("All");


  const [totalOfRow, settotalOfRow] = useState(null);
  const isDisabled = Object.keys(formik.values.account).length === 0

  const calculateProfileCompletion = (user) => {
    const {
      account,
      createdAt,
      id,
      member_id,
      profile_img,
      relationship,
      _id,
      backGround,
      account_id,
      organization,
      updatedAt,
      __v,
      ...data
    } = { ...(user ? user : {}) };
    const insertedValues = Object.values(data);
    const insertedValuesLng = insertedValues.filter((it) => {
      if (it !== "") {
        if (typeof it === "object") {
          if (it?.formattedAddress !== undefined) {
            return true;
          } else return false;
        }
        return true;
      } else return false;
    })?.length;
    return Math.round((insertedValuesLng / 23) * 100) > 100
      ? 100
      : Math.round((insertedValuesLng / 23) * 100);
  };
  const handleFilters = async (withoutFilter, filterPage, account_type) => {
    if (filterPage === 1) {
      setPage(1);
      setPeoplePage(1);
    }
    //Hit Account Api
    const token = await getAccessTokenSilently();
    if (token) {
      if (toggle) {
        formik.setFieldValue("people", {});
        const data = {
          filter: {
            account_type: account_type || formik.values?.account_type,
            ...(withoutFilter ? {} : {
              category: formik.values.account?.category?.[0] === '-1' ? ['-1'] : formik.values.account?.category?.map(item => item.title),
              billing_type: formik.values.account?.billing_type?.[0] === '-1' ? ['-1'] : formik.values.account?.billing_type?.map(item => item.title),
              accounts: formik.values.account?.accounts?.[0] === '-1' ? ['-1'] : formik.values.account?.accounts?.map(item => item._id),
              contacts: formik.values.account?.contacts?.[0] === '-1' ? ['-1'] : formik.values.account?.contacts?.map(item => item.id),
              archived: formik.values.account?.archived,
              accountTags: formik.values.account?.accountTags?.[0] === '-1' ? ['-1'] : formik.values.account?.accountTags?.map(item => item.title),
              contactTags: formik.values.account?.contactTags?.[0] === '-1' ? ['-1'] : formik.values.account?.contactTags?.map(item => item.title),
            })
          }
        }

        if (accountView === "grid") {
          data.screen = "list";
        }
        const perPage = accountView === "grid" ? 30 : 20;
        enableLoading(true);
        await MemberService.getAccountWithFilter(data, token, filterPage, perPage)
          .then((res) => {
            if (res) {
              if (accountView === "cards") {
                let i = 0;
                const result = res?.payload?.data?.map((item, index) => {
                  if (i === 5) i = 0;
                  item.backGround = colors[i];
                  i++;
                  return item;
                });
                setData(result);

              } else {
                const result = res?.payload?.data;
                setAccountCardsData(result?.map((item) => {
                  return {
                    ...item,
                    id: item.accountId,
                  }
                }));
              }
              settotalOfRow(res?.payload?.pagination?.count);
              setClickedPage(res?.payload?.pagination?.items_per_page);
              enableLoading(false);
              withoutFilter && formik.setFieldValue("clear", false);

            }
          })
          .catch((err) => {
            // toastr.error("Error", err?.data?.message);
            enableLoading(false);
            withoutFilter && formik.setFieldValue("clear", false);

          });
      } else {
        formik.setFieldValue('account_type', ['-1']);
        const isEndAgeEmpty = formik.values.people?.ageRange?.end?.trim() === ''
        // -1 means that I checked all items for the specific field
        const data = {
          filter: {
            ...(withoutFilter ? {} : {
              category: formik.values.account?.category?.[0] === '-1' ? ['-1'] : formik.values.account?.category?.map(item => item.title),
              billing_type: formik.values.account?.billing_type?.[0] === '-1' ? ['-1'] : formik.values.account?.billing_type?.map(item => item.title),
              accounts: formik.values.account?.accounts?.[0] === '-1' ? ['-1'] : formik.values.account?.accounts?.map(item => item._id),
              contacts: formik.values.account?.contacts?.[0] === '-1' ? ['-1'] : formik.values.account?.contacts?.map(item => item.id),
              archived: formik.values.account?.archived,
              accountTags: formik.values.account?.accountTags?.[0] === '-1' ? ['-1'] : formik.values.account?.accountTags?.map(item => item.title),
              contactTags: formik.values.account?.contactTags?.[0] === '-1' ? ['-1'] : formik.values.account?.contactTags?.map(item => item.title),
            })
          }
        }

        enableLoading(true);
        await MemberService.getPeopleWithFilter(data, token, peoplePage, 30)
          .then((res) => {
            if (res) {
              const result = res?.payload?.data.map((item) => {
                item.id = item._id;
                const random = Math.floor(Math.random() * 2);
                if (!item.profile_img) {
                  item.backGround = colors[random];
                }
                item.profile_completion = calculateProfileCompletion(item);
                return item;
              });
              setPeopleList(result);
              setTotalPeople(res?.payload?.pagination?.count);
            }
            enableLoading(false);
            withoutFilter && formik.setFieldValue("clear", false);
            formik.setFieldValue("error", false);

          })
          .catch((err) => {
            // toastr.error("Error", err?.data?.message);
            if (err?.data?.message === 'validation error') {
              formik.setFieldValue("error", true)
            }

            enableLoading(false);
            withoutFilter && formik.setFieldValue("clear", false);
          });

      }
    }
  }

  const enableLoading = (value) => {
    setLoading(value);
  };
  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const colors = [
    {
      color: " rgba(250, 51, 114, 1)",
      background: " rgba(250, 51, 114, 0.1)",
      bgColor: "250, 51, 114",
    },
    {
      color: "rgba(37, 85, 239,1)",
      background: "rgba(37, 85, 239,0.1)",
      bgColor: "37, 85, 239",
    },
    {
      color: "rgba(40, 194, 56, 1)",
      background: "rgba(40, 194, 56, 0.1)",
      bgColor: "40, 194, 56",
    },
    {
      color: "rgba(255, 128, 10, 1)",
      background: "rgba(255, 128, 10, 0.1)",
      bgColor: "255, 128, 10",
    },
    {
      color: "rgba(37, 85, 239,1)",
      background: "rgba(37, 85, 239,0.1)",
      bgColor: "37, 85, 239",
    },
  ];

  const ClearFilter = () => {
    setPeoplePage(1);
    setPage(1);
    formik.setFieldValue("account", {});
    formik.setFieldValue("people", {});
    formik.setFieldValue("clear", true);
    formik.setFieldValue("error", false);
    setAppliedFilters(false);
    handleFilters(true, 1)
  }
  useEffect(() => {
    window.scrollTo(0, 0);
    handleFilters(!appliedFilters, pageFilter)
    enableLoading(true);
  }, [getAccessTokenSilently, history, page, show, refresh, toggle, peoplePage, accountView]);

  useEffect(() => {
  }, [openAddModel]);
  useEffect(() => {
    setIsMembersActive(
      orgInfo?.find((item) => item?.moduleName === "members")?.active
    );

  }, []);

  const getExportAccountsDataHandler = async () => {
    setExportAccountsData([]);
    let exportAccountsData = [];
    const data = {
      filter: {
        account_type: formik.values?.account_type,
        ...(!appliedFilters ? {} : {
          category: formik.values.account?.category?.[0] === '-1' ? ['-1'] : formik.values.account?.category?.map(item => item.title),
          billing_type: formik.values.account?.billing_type?.[0] === '-1' ? ['-1'] : formik.values.account?.billing_type?.map(item => item.title),
          accounts: formik.values.account?.accounts?.[0] === '-1' ? ['-1'] : formik.values.account?.accounts?.map(item => item._id),
          contacts: formik.values.account?.contacts?.[0] === '-1' ? ['-1'] : formik.values.account?.contacts?.map(item => item.id),
          archived: formik.values.account?.archived,
          accountTags: formik.values.account?.accountTags?.[0] === '-1' ? ['-1'] : formik.values.account?.accountTags?.map(item => item.title),
          contactTags: formik.values.account?.contactTags?.[0] === '-1' ? ['-1'] : formik.values.account?.contactTags?.map(item => item.title),
        })
      }
    }
    const token = await getAccessTokenSilently();
    await MemberService.getExportAccounts({
      token,
      data,
    })
      .then((res) => {
        const result = res?.result?.length ? res?.result : [];
        setExportAccountsData(result);
        exportAccountsData = result;
      })
      .catch((error) => {
        toastr.error(error?.data?.message || "Something went wrong");
      }).finally(() => {
      });

    return exportAccountsData;
  };

  const getExportContactsDataHandler = async () => {
    let exportContactsData = [];
    setExportContactsData([]);
    const data = {
      filter: {
        ...(!appliedFilters ? {} : {
          category: formik.values.account?.category?.[0] === '-1' ? ['-1'] : formik.values.account?.category?.map(item => item.title),
          billing_type: formik.values.account?.billing_type?.[0] === '-1' ? ['-1'] : formik.values.account?.billing_type?.map(item => item.title),
          accounts: formik.values.account?.accounts?.[0] === '-1' ? ['-1'] : formik.values.account?.accounts?.map(item => item._id),
          contacts: formik.values.account?.contacts?.[0] === '-1' ? ['-1'] : formik.values.account?.contacts?.map(item => item.id),
          archived: formik.values.account?.archived,
          accountTags: formik.values.account?.accountTags?.[0] === '-1' ? ['-1'] : formik.values.account?.accountTags?.map(item => item.title),
          contactTags: formik.values.account?.contactTags?.[0] === '-1' ? ['-1'] : formik.values.account?.contactTags?.map(item => item.title),
        })
      }
    }
    const token = await getAccessTokenSilently();


    await MemberService.getExportContacts({
      token,
      data,
    })
      .then((res) => {
        const result = res?.result?.length ? res?.result : [];
        setExportContactsData(result);
        exportContactsData = result;
      })
      .catch((error) => {
        toastr.error(error?.data?.message || "Something went wrong");
      }).finally(() => {
      });
    return exportContactsData;
  };


  const handleOpenFilters = () => {
    setOpenFilters(!openFilters)
  }
  const onStatusChange = (status) => {
    formik.setFieldValue('account_type', [status]);
    handleFilters(!appliedFilters, 1, [status])
  }

  const openInvitationModelHandler = (dataRow) => {
    setOpenInvitationModel(true);
    setCurrentContact(dataRow)
  }

  const openDisableMemberUserHandler = (dataRow) => {
    setDisableMemberUserModal((prev) => ({
      ...prev,
      open: true,
      data: dataRow,
    }));
  }

  const closeDisableMemberUserHandler = () => {
    setDisableMemberUserModal((prev) => ({
      ...prev,
      open: false,
      data: {},
    }));
  }

  const disableMemberUserHandler = async () => {
    setDisableMemberUserModal((prev) => ({
      ...prev,
      loading: true,
    }));
    const token = await getAccessTokenSilently();
    await UserService.disableMemberUser({ token, contactId: disableMemberUSerModal?.data?._id })
      .then((res) => {
        closeDisableMemberUserHandler();
        refreshData();
        toastr.success("Success", "Member disabled successfully");
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message ?? "Something Went Wrong");
      }).finally(() => {
        setDisableMemberUserModal((prev) => ({
          ...prev,
          loading: false,
        }));
      })
  }

  const refreshData = () => {
    setRefresh(!refresh);
  };

  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenAddModel(false);
  }

  const onAccountViewChange = (view) => {
    setAccountView(view);
    setPage(1);
    localStorage.setItem("accountView", view);
  }



  const accountsExportData = useCallback((resultData) => {
    const accountData = [];
    if (!resultData?.length) return accountData;
    const data = resultData?.map((account) => {
      return accountData.push({
        memberId: account?.["Member ID"],
        accountName: account?.["Account name"],
        adult1: account?.["Adult 1"],
        adult2: account?.["Adult 2"],
        email1: account?.["Email 1"],
        email2: account?.["Email 2"],
        mobile1: account?.["Mobile 1"] ? formatPhoneNumber(account?.["Mobile 1"]) : "",
        mobile2: account?.["Mobile 2"] ? formatPhoneNumber(account?.["Mobile 2"]) : "",
        home1: account?.["Home 1"] ? formatPhoneNumber(account?.["Home 1"]) : "",
        home2: account?.["Home 2"] ? formatPhoneNumber(account?.["Home 2"]) : "",
        familyMembers: account?.["Family member's list"],
        activeAddress: account?.["Active address"],
        billingAddress: account?.["Billing address"],
        accountType: account?.["Account type"],
        billingType: account?.["Billing type"],
        accountTags: account?.["Account tags"],
      });
    });
    return accountData;
  }, []);

  const contactsExportData = useCallback((resultData) => {
    const contactsData = [];
    if (!resultData?.length) return contactsData;
    const data = resultData?.map((contact) => {
      return contactsData.push({
        contactId: contact?.["Contact Id"],
        familyName: contact?.["Family Name"],
        firstName: contact?.["First Name"],
        lastName: contact?.["Last Name"],
        mobile: contact?.["Mobile"] ? formatPhoneNumber(contact?.["Mobile"]) : "",
        homePhone: contact?.["Home Phone"] ? formatPhoneNumber(contact?.["Home Phone"]) : "",
        email: contact?.["Email"],
        address: contact?.["Address"],
        contactTags: contact?.["Contact tags"],
      });
    });
    return contactsData;
  }, []);


  const exportColumnsHandler = useCallback(() => {
    return toggle ? accountColumns : contactColumns;
  }, [toggle]);

  const exportDataHandler = useCallback((resultData) => {
    return toggle ? accountsExportData(resultData) : contactsExportData(resultData);
  }, [toggle, accountsExportData, contactsExportData]);


  const getExportDataHandler = async () => {
    return toggle ? await getExportAccountsDataHandler() : await getExportContactsDataHandler();
  }

  const headerColumns = exportColumnsHandler();

  const generateCsv = async () => {
    setIsExportLoading(true);
    const resultData = await getExportDataHandler();
    const exportData = exportDataHandler(resultData)
    setIsExportLoading(false);
    return exportData;
  }


  const generateExcel = async () => {
    setIsExportLoading(true);
    const resultData = await getExportDataHandler();
    const exportData = exportDataHandler(resultData)
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(exportData));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      toggle ? "accounts.xlsx" : "people.xlsx"
    );
    setIsExportLoading(false);
  };


  const reportFileNameHandler = () => {
    return toggle ? "Accounts" : "People";
  }




  return !isMembersActive ? (
    <NotAuthorized title={"Members"} />
  ) : (
    <>
      <div className="members pt-10 pb-8">
        <div className="d-flex justify-content-between align-items-center subHeader">
          <SubHeader
            className="subheader"
            {...{
              title: "Members",
              color: "#2455EF",
            }}
          />
          <div className="d-flex memberBtn">
            <Button
              variant="primary-outline"
              onClick={() => setOpenAddModel(true)}
              style={{
                gap: 0,
                minWidth: 170,
              }}
            >
              <AddAccounSVG />
              <span>Add New {toggle ? "Account" : "User"}</span>
            </Button>
          </div>
        </div>

        <MainTabs
          className="mt-10"
          tabs={memberTabs}
          activeTab={toggle ? "account" : "people"}
          onTabsChange={(tab) => {
            setOpenFilters(false);
            setToggle(tab?.value === "account");
          }}
        />
        <div className="d-flex justify-content-between align-items-center">
          {!loading && (
            <div className="d-flex align-items-center member-total-counts">
              <strong className="total-count">
                {toggle ? totalOfRow || 0 : totalPeople || 0}
              </strong>
              <span className="total-count-text">{toggle ? "Accounts" : "People"}</span>
            </div>
          )}


          <FiltersWrapper>
            {toggle &&
              <FilterTabs
                tabs={filterVariables.AccountTypes}
                activeTab={formik.values?.account_type?.[0] || 'member'}
                onTabsChange={(tab) => {
                  onStatusChange(tab?.value)
                }}
              />
            }
            <Button
              variant="filter"
              onClick={handleOpenFilters}
            >
              {(appliedFilters && Object.keys(formik.values["account"]).length !== 0) ?
                <FilterActive /> :
                <FilterIcon />
              }
              <span>Filter</span>
            </Button>
            {/* <Filters>
            <Button onClick={handleOpenFilters}>{Object.keys(formik.values[pageTab]).length !== 0 ? <FilterActive /> : <FilterIcon
              style={{ width: '19px', height: '17px' }} />}<span>Filter</span>
            </Button>
          </Filters> */}
          </FiltersWrapper>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          {toggle ? (
            <div
              className="d-flex align-items-center mr-5"
              style={{
                height: "44px",
                backgroundColor: "#e7edf9",
                borderRadius: "4px",
              }}
            >
              <button
                type="button"
                onClick={() => {
                  if (loading) return;
                  onAccountViewChange("cards");
                }}
                className={
                  accountView === "cards"
                    ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                    : `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
                }
                disabled={loading}
              >
                <GridViewIcon
                  sx={{
                    color: accountView === "cards" ? "#FFFFFF" : "#2555EF",
                    width: "20px !important",
                    height: "20px !important",
                  }}
                />
              </button>
              <button
                type="button"
                onClick={() => {
                  if (loading) return;
                  onAccountViewChange("grid");
                }}
                className={
                  accountView === "grid"
                    ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                    : `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
                }
                disabled={loading}
              >
                <FormatListBulletedIcon
                  sx={{
                    color: accountView === "grid" ? "#FFFFFF" : "#2555EF",
                    width: "20px !important",
                    height: "20px !important",
                  }}
                />
              </button>
            </div>
          ) : <div></div>}
          <ExportOptions
            columns={headerColumns}
            datas={generateCsv}
            downloadExcel={generateExcel}
            isLoading={isExportLoading}
            setLoading={setIsExportLoading}
            tableContainerRef={tableContainerRef}
            reportFileNameHandler={reportFileNameHandler}
            showPrint={false}
          />
        </div>
        {openFilters && <Wrapper className="mt-4">
          <MemberFilters setOpenFilters={setOpenFilters} openFilters={openFilters} isAccount={toggle} formik={formik} handleOpenFilters={handleOpenFilters} />
          <WrapperButtons>
            <Button
              onClick={ClearFilter}
              variant="primary-outline"
              size="md"
              style={{ minWidth: "100px" }}
            >
              <span>Clear</span>
            </Button>
            <Button
              onClick={() => {
                handleFilters(false, 1);
                setPage(1);
                setPeoplePage(1);
                setAppliedFilters(true);
              }}
              disabled={isDisabled || loading}
              variant="primary"
              size="md"
              style={{ minWidth: "100px" }}
            >
              {loading ? <PulseLoader color={'#fff'} size={'7px'} style={{ marginTop: '-2px' }} /> : 'Filter'}
            </Button>
          </WrapperButtons>
        </Wrapper>}
        {toggle ? (
          <>
            {accountView === "cards" ? (
              <div>
                <GridComponent
                  loading={loading}
                  data={data}
                  setPage={setPage}
                  page={page}
                  size={20}
                  refresh={refresh}
                  setRefresh={setRefresh}
                  formik={formik}
                // pagination={true}
                // paginationMode="server"
                // rowCount={Math.ceil(total / 20)}
                />
                <div
                  className={
                    loading ? "d-none" : "pagination-custom mt-2 mb-4 py-4"
                  }
                >
                  <Pagination
                    // defaultPage={page}
                    count={Math.ceil(totalOfRow / 20)}
                    color="primary"
                    page={page}
                    variant="outlined"
                    onChange={(event, value) => {
                      setPage(value);
                    }}
                  />
                </div>
              </div>
            ) : (
              <AccountListView
                list={accountCardsData}
                loading={loading}
                totalCount={totalOfRow}
                page={page}
                setPage={setPage}
                perPage={30}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            )}
          </>
        ) : (
          <>
            <MemberTable
              setRefresh={setRefresh}
              refresh={refresh}
              show={show}
              userFamily={userFamily}
              setUserFamily={setUserFamily}
              peopleTotalList={totalPeople}
              peoplelist={peoplelist}
              setTotalPeople={setTotalPeople}
              setPeopleList={setPeopleList}
              isPeopleMember={true}
              setPeoplePage={setPeoplePage}
              peoplePage={peoplePage}
              openInvitationModelHandler={openInvitationModelHandler}
              openDisableMemberUserHandler={openDisableMemberUserHandler}
              peopleLoading={loading}
            />
          </>

        )}
        <MyModal
          className="invite-modal"
          open={openModel}
          onClose={() => {
            setOpenModel(false);
          }}
        >
          <InviteMember />
        </MyModal>
        <MyModal
          className="invite-modal"
          open={openAddModel}
          onClose={closeModal}
        >
          {toggle ? (
            <AddNewAccount
              setOpen={setOpenAddModel}
              refresh={refresh}
              setRefresh={setRefresh}
              closeModal={closeModal}
              source="members"
            />
          ) : (
            <AddNewUser
              setOpen={setOpenAddModel}
              setRefresh={setRefresh}
              refresh={refresh}
              userFamily={userFamily}
            />
          )}
        </MyModal>
        <MyModal
          open={showFilter}
          onClose={handleCloseFilter}
          className="filter-card"
        >
          <Filter from="createFilter" />
        </MyModal>
        <MyModal
          className="invite-people-modal"
          open={openInvitationModel}
          onClose={() => {
            setOpenInvitationModel(false);
          }}
        >
          <InvitationModal
            closeModal={() => setOpenInvitationModel(false)}
            contactId={currentContact?._id}
            defaultEmail={currentContact?.email_address}
            refreshData={refreshData}
          />
        </MyModal>
        <AlertDialog
          open={disableMemberUSerModal.open}
          onDecline={closeDisableMemberUserHandler}
          onAccept={disableMemberUserHandler}
          title={"Are you sure?"}
          description={"Do you want to disable this member?"}
        />
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
          disabled={disableMemberUSerModal.loading}
        />
      </div >
    </>
  );
};
export default Members;
